import React from "react";

const TextAreaInput = (props) => {
  return (
    <textarea
      cols="30"
      rows="10"
      value={props.value}
      onChange={(e) => props.onChange(e.target.value)}
    />
  );
};

export default TextAreaInput;
